import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showForm } from '../../store/formSlice';
import { HelpPanel } from './HelpPanel';
import help from './help.json';
import { pick } from 'lodash';

const HelpPanelContainer = () => {
    const dispatch = useDispatch();
    const { visible } = useSelector(state => state.form);
    const { faq } = help;
    const [ question, setQuestion ] = useState(null);

    return(
        visible === "help"
            ? <HelpPanel
                questions={faq.map((f, idx) => ({ key: idx, ...pick(f, ["question"]) }))}
                onShowQuestion={(key) => setQuestion(faq[key])}
                onClose={() => dispatch(showForm(false))}
                onCloseQuestion={() => setQuestion(null)}
                question={question}
            />
            : null
    )
};

export { HelpPanelContainer };
